<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaServiciuPostVanzare')}}</h4>
        </div>
        <form class="add-user-form" id='edit-post-service' method="POST">
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_1" :key="input_field.id">
                        <input type="text" class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               v-model="input_field.inputValue"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName"
                               >
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <input type="text"
                               class="form-control"
                               placeholder=""
                               v-validate="input_field.validationRules"
                               :name="input_field.inputName"
                               :data-vv-as="input_field.labelName"
                               :id="input_field.inputName"
                               v-model="input_field.inputValue">
                        <label class=""> {{input_field.labelName}} </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                            <i v-bind:class="input_field.icon"></i>
                        </span>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div class="save-contact-buttons col-md-12 col-xs-12 col-lg-12">
                    <button type="button" @click='updatePostService()'>
                        <i class="fas fa-check"></i>
                        {{$t('placeholder.salveaza')}}
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import PostServicesService from '../../api-services/post_services.service.js'
export default {
  name: 'editpostservice',
  data () {
    return {
      post_service: [],
      offer_dues: null
    }
  },
  methods: {
    getPostService () {
      PostServicesService.get(this.$route.params.id)
        .then((response) => {
          this.post_service = response.data.data
          this.offer_dues = this.post_service.offer_due
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('hideLoading')
        })
    },
    updatePostService () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-post-service'))
      PostServicesService.update(this.$route.params.id, formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.post_service = response.data.data
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.postServiciuModificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'ord',
            labelName: this.$t('placeholder.ord'),
            inputValue: (this.post_service) ? this.post_service.ord : null,
            icon: 'fas fa-file-signature'
          },
          {
            inputName: 'name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.post_service) ? this.post_service.name : null,
            icon: 'fas fa-donate'

          },
          {
            inputName: 'value',
            labelName: this.$t('placeholder.valoare'),
            inputValue: (this.post_service) ? this.post_service.value : null,
            icon: 'fas fa-money-bill-wave info-tool'
          }
        ],
        column_2: [
          {
            inputName: 'price',
            labelName: this.$t('placeholder.pret'),
            inputValue: (this.post_service) ? this.post_service.price : null,
            icon: 'fas fa-file-signature'
          }
        ]
      }
    }
  },
  created () {
    this.getPostService()
  }
}
</script>
